import React from 'react';
import { Icon } from './Icon.js';
export const IconMsgFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,.001C2.691.001,0,2.693,0,6.001c0,1.08.287,2.127.833,3.049-.178.64-.422,1.247-.744,1.846-.124.232-.118.513.018.739.136.228.379.405.647.365,1.093,0,2.077-.163,2.932-.483.752.321,1.529.483,2.314.483,3.309,0,6-2.691,6-6S9.309.001,6,.001Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconMsgFill12.js.map